 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGH from '@/components/html/03_Copyrigh'
 import HTML02_TITLE_PA from '@/components/html/02_Title_Pa'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_1___CLIM from '@/components/html/05_1___Clim'
 import HTML06_PART_1_A from '@/components/html/06_Part_1_A'
 import HTML07_2___RECE from '@/components/html/07_2___Rece'
 import HTML08_3___NATU from '@/components/html/08_3___Natu'
 import HTML09_4___DEMO from '@/components/html/09_4___Demo'
 import HTML10_5___MODE from '@/components/html/10_5___Mode'
 import HTML11_6___CAN from '@/components/html/11_6___Can'
 import HTML12_7___RAPI from '@/components/html/12_7___Rapi'
 import HTML13_COLOR_PL from '@/components/html/13_Color_pl'
 import HTML14_PART_2_C from '@/components/html/14_Part_2_C'
 import HTML15_8___CHAN from '@/components/html/15_8___Chan'
 import HTML16_9___ECOL from '@/components/html/16_9___Ecol'
 import HTML17_10___ARC from '@/components/html/17_10___Arc'
 import HTML18_11___ISL from '@/components/html/18_11___Isl'
 import HTML19_12___RET from '@/components/html/19_12___Ret'
 import HTML20_13___SEN from '@/components/html/20_13___Sen'
 import HTML21_PART_3_P from '@/components/html/21_Part_3_P'
 import HTML22_14___HAR from '@/components/html/22_14___Har'
 import HTML23_15___FRO from '@/components/html/23_15___Fro'
 import HTML24_16___RES from '@/components/html/24_16___Res'
 import HTML25_17___ASS from '@/components/html/25_17___Ass'
 import HTML26_18___THE from '@/components/html/26_18___The'
 import HTML27_CONCLUDI from '@/components/html/27_Concludi'
 import HTML28_19___WHA from '@/components/html/28_19___Wha'
 import HTML29A_NOT from '@/components/html/29a_Not'
 import HTML29_INDEX from '@/components/html/29_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_1___Clim",
 			"name" : "html/05_1___Clim",
 			"component" : HTML05_1___CLIM
 		},
 		{
 			"path" : "/html/06_Part_1_A",
 			"name" : "html/06_Part_1_A",
 			"component" : HTML06_PART_1_A
 		},
 		{
 			"path" : "/html/07_2___Rece",
 			"name" : "html/07_2___Rece",
 			"component" : HTML07_2___RECE
 		},
 		{
 			"path" : "/html/08_3___Natu",
 			"name" : "html/08_3___Natu",
 			"component" : HTML08_3___NATU
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js